module.exports = __webpack_public_path__ + "img/localadventures-payments-mxn.2efecaf.svg";